import { handleActions } from 'redux-actions'
import * as type from './type'
import { changeTableSettings, createInitialTableState } from '../../../../form/state/table-state-helper'


export const initialState = {
    foilList: [],
    fetching: false,
    error: null,
    ...createInitialTableState({
        rowsPerPage: 20,
        sortColumnName: 'status',
        sortOrder: 1,
    }),
}

export default handleActions({
    [type.CHANGE_TABLE_SETTING]: changeTableSettings(),

    [type.FIND_FOIL_LIST_REQUEST]: (state) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_FOIL_LIST_SUCCESS]: (state, action) => {
        const { foilList } = action.payload
        return {
            ...state,
            foilList,
            fetching: false,
        }
    },
    [type.FIND_FOIL_LIST_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/foil/state/overview/info-table/reducer.js